import Header from './en/header-menu';
import SubscriptionForm from './en/subscription-form';
import Footer from './en/footer';
import HomePage from './en/home-page';
import TrinityCerttesolPage from './en/trinity-certtesol-page';
import OnlineCerttesolPage from './en/online-trinity-certtesol';
import DevelopingTeacherPage from './en/developing-teacher-page';
import BarcelonaPage from './en/barcelona-page';
import SevilliePage from './en/sevillie-page';
import DatesAndFeesPage from './en/dates-and-fees';
import PaymentPlanPage from './en/payment-plan-page';
import SpecialOffersPage from './en/special-offers-page';
import CareersServicePage from './en/careers-service-page';
import AccommodationPage from './en/accommodation-page';
import ResourcesPage from './en/resources-page';
import AboutPage from './en/about-page';
import WhatIsTeflPage from './en/what-is-tefl-page';
import AccreditationPage from './en/accreditation-page';
import TeamPage from './en/team-page';
import GraduatesPage from './en/graduates-page';
import WorkWithUsPage from './en/work-with-us-page';
import EntryPage from './en/entry-requirements';
import ContactUsPage from './en/contacto-page';
import FaqsPage from './en/faqs-page';
import BlogPage from './en/blog';
import StudentsVisaPage from './en/student-visas';
import HowToMakeGoodAppPage from './en/how-to-make-good-app-page';
import ApplyPage from './en/apply-page';
import TermsPage from './en/terms-and-conditions';
import PrivacyPage from './en/privacy-page';
import AllCoursesPage from './en/all-courses';
import SpanishCoursePage from './en/spanish-course-page';
import TeachingKidsPage from './en/teaching-young-learners-page';
import ClassesDeInglesPage from './en/classes-de-ingles-page';
import Components from './en/components';

import URLS from './en/urls';

const translation = {
  prefix: 'en',
  ...Header,
  ...Footer,
  ...HomePage,
  ...TrinityCerttesolPage,
  ...OnlineCerttesolPage,
  ...SubscriptionForm,
  ...DevelopingTeacherPage,
  ...BarcelonaPage,
  ...SevilliePage,
  ...DatesAndFeesPage,
  ...PaymentPlanPage,
  ...SpecialOffersPage,
  ...CareersServicePage,
  ...AccommodationPage,
  ...ResourcesPage,
  ...AboutPage,
  ...WhatIsTeflPage,
  ...AccreditationPage,
  ...TeamPage,
  ...GraduatesPage,
  ...WorkWithUsPage,
  ...EntryPage,
  ...ContactUsPage,
  ...FaqsPage,
  ...BlogPage,
  ...StudentsVisaPage,
  ...HowToMakeGoodAppPage,
  ...ApplyPage,
  ...TermsPage,
  ...PrivacyPage,
  ...AllCoursesPage,
  ...SpanishCoursePage,
  ...TeachingKidsPage,
  ...ClassesDeInglesPage,
  ...Components,
  ...URLS,
};

export default translation;
